import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta17Model,
  ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum,
} from './model-consultaSeguimentoPergunta17'

const pergunta17TentaFazerQueOlheEnum = Object.values(ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum)

export const isPergunta17TentaFazerQueOlheAllNao = (
  value: ConsultaSeguimentoPergunta17Model['PERGUNTA_17_TENTA_FAZER_QUE_OLHE']
): boolean => {
  return isAllNao(value, pergunta17TentaFazerQueOlheEnum)
}
